<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="pacotes"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('documentos.editar_pacotes')"
            depressed
            color="accent"
            :to="{ name: 'pacote-documento-novo' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo pacote
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.cliente="{ item }">
        <span class="caption text--disabled"
          >{{ documentoCliente(item.cliente) }}
          {{ item.cliente.razao_social }}</span
        ><br />
        {{ item.cliente.nome }}
      </template>
      <template v-slot:item.enviado="{ item }">
        <v-icon
          :class="
            item.enviado
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          small
          :to="{ name: 'pacote-documento-docs', params: { id: item.id } }"
        >
          <v-icon>mdi-package-variant</v-icon>
        </v-btn>
        <pacote-log-envios :pacote="item" v-if="item.enviado">
          <v-btn icon small>
            <v-icon>
              mdi-send-clock-outline
            </v-icon>
          </v-btn>
        </pacote-log-envios>
        <v-btn
          icon
          small
          text
          v-if="perms.includes('documentos.editar_pacotes')"
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          titulo="Deletar pacote de documentos"
          texto="Confirma a exclusão?"
          v-if="!item.enviado && perms.includes('documentos.excluir_pacotes')"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import PacoteLogEnvios from "../components/documentos/PacoteLogEnvios";
import { build } from "../lib/masks";
export default {
  components: { DatatableFilters, DialogConfirm, PacoteLogEnvios },
  data() {
    return {
      headers: [
        { text: "#", value: "id", align: "center" },
        { text: "Cliente", value: "cliente" },
        { text: "Título", value: "titulo" },
        { text: "Descrição", value: "descricao" },
        { text: "Enviado", value: "enviado", align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      pacotes: [],
      filters: [
        {
          name: "id_cliente",
          label: "Cliente",
          type: "select",
          options: [],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.pacotes_documentos") || `{}`
      ),
      loading: false,
    };
  },
  computed: mapState({
    clientes: (state) => state.cliente.clientes,
    perms: (state) => state.usuarios.usuarioAtivo.permissoes,
  }),
  methods: {
    async listar() {
      this.loading = true;
      try {
        this.pacotes = await this.$store.dispatch("documento/listarPacotes", {
          filtros: this.filtrosAtivos,
        });
      } catch (e) {
        console.log(e);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível listar os pacotes de documentos.",
        });
      }
      this.loading = false;
    },
    editar(id) {
      this.$router.push({ name: "pacote-documento-detalhes", params: { id } });
    },
    async deletar(id_pacote) {
      try {
        await this.$store.dispatch("documento/removerPacote", id_pacote);
        this.listar();
      } catch (err) {
        console.log(err);
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível remover o pacote de documentos.",
        });
      }
    },
    documentoCliente(cliente) {
      if (cliente.tipo == "F") {
        return "CPF: " + build.cpf(cliente.cpf_cnpj);
      }
      return "CNPJ: " + build.cnpj(cliente.cpf_cnpj);
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.pacotes_documentos", JSON.stringify(val));
      this.listar();
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Pacotes de documentos",
    });
    this.loading = true;
    this.$store.dispatch("cliente/listar", {}).then((clientes) => {
      this.filters.find(
        (f) => f.name === "id_cliente"
      ).options = clientes.data.map((e) => ({
        text: e.nome,
        value: e.id,
      }));
    });
    this.listar();
    this.loading = false;
  },
};
</script>
